// extracted by mini-css-extract-plugin
module.exports = {"container":"mindmapOrientationPicker_container__aCY2D","button":"mindmapOrientationPicker_button__viGw6"};